import config from '../utils/config';

export interface StripeCard {
  name: string;
  exp_month: number;
  exp_year: number;
  number: number;
  cvc: number;
}

class StripeService {
  private getStripeInstance() {
    if (config.isClientSide) {
      return (window as any).Stripe;
    }

    return null;
  }

  getCardType(cardNumber: number): string {
    const windowStripe = this.getStripeInstance();
    if (windowStripe && cardNumber) {
      return windowStripe.card.cardType(cardNumber);
    }

    return 'Visa';
  }

  isAmexCard(cardNumber: number): boolean {
    return this.getCardType(cardNumber) === 'American Express';
  }

  createCardToken(card: StripeCard) {
    const windowStripe = this.getStripeInstance();

    if (windowStripe) {
      return new Promise((resolve, reject) => {
        windowStripe.card.createToken(card, (status, data) => {
          if (status <= 204) {
            return resolve(data);
          }

          const errorMessage = (data.error && data.error.message)
            || 'Something went wrong with your input card';
          return reject({
            error: {
              message: errorMessage,
            },
          });
        });
      });
    }

    return Promise.reject({
      error: {
        message: 'Something went wrong with your input card',
      },
    });
  }
}

export default new StripeService();
